import { useRef, useEffect } from 'react';
import * as THREE from 'three';

export default function useHelicopterMovement(rigRef) {
    const moveRef = useRef({
        active: false,
        from: new THREE.Vector3(),
        to: new THREE.Vector3(),
        fromRotY: 0,
        toRotY: 0,
        t0: 0,
        duration: 2.0,
        delay: 0.0,
        captureFromOnStart: false,
        captured: true,
        onComplete: null,
        onCompleteCalled: false,
    });

    // Para mover el helicóptero a una posición y rotación destino, con fases y callbacks
    function moveTo(dest, {
        duration = 2,
        delay = 0,
        fromRotY = null,
        toRotY = null,
        captureFromOnStart = false,
        onComplete = null,
    } = {}) {
        const now = performance.now() / 1000;
        // if (phase && setPhase) setPhase(phase);
        moveRef.current.active = true;
        moveRef.current.to.copy(new THREE.Vector3(dest.x, dest.y, dest.z));
        moveRef.current.t0 = now;
        moveRef.current.duration = duration;
        moveRef.current.delay = delay;
        moveRef.current.captureFromOnStart = captureFromOnStart;
        moveRef.current.captured = !captureFromOnStart;
        moveRef.current.onComplete = onComplete;
        moveRef.current.onCompleteCalled = false;

        // Rotación: aplicar offset manual del usuario
        // const manualOffset = dragStateRef?.current?.manualOffset || 0;
        if (fromRotY !== null) {
            moveRef.current.fromRotY = fromRotY; // + manualOffset;
            // if (dragStateRef?.current) dragStateRef.current.baseRotation = fromRotY;
        } else {
            moveRef.current.fromRotY = rigRef.current?.rotation.y; // || 0;
        }
        if (toRotY !== null) {
            moveRef.current.toRotY = toRotY; // + manualOffset;
        } else {
            moveRef.current.toRotY = rigRef.current?.rotation.y || 0;
        }

        // Posición inicial
        if (!captureFromOnStart && rigRef.current) {
            moveRef.current.from.copy(rigRef.current.position);
        }
    }

    // Se llama en cada frame. Para usar dentro de un useFrame
    function updateMovement() {
        const mRef = moveRef.current;
        // console.log("updateMovement", mRef.active);
        const rig = rigRef.current;
        if (!mRef.active || !rig) return;

        const now = performance.now() / 1000;
        const elapsed = now - mRef.t0;
        if (elapsed >= mRef.delay) {
            // Capturar FROM al arrancar (si corresponde)
            if (mRef.captureFromOnStart && !mRef.captured) {
                mRef.from.copy(rig.position);
                mRef.fromRotY = rig.rotation.y;
                mRef.captured = true;
            }

            const p = Math.min((elapsed - mRef.delay) / mRef.duration, 1.0);
            const e = p * p * (3 - 2 * p); // easeInOut

            rig.position.lerpVectors(mRef.from, mRef.to, e);
            // Interpolación de rotación Y por el camino más corto
            let delta = mRef.toRotY - mRef.fromRotY;
            if (delta > Math.PI) delta -= Math.PI * 2;
            if (delta < -Math.PI) delta += Math.PI * 2;
            if (p < 1.0) {
                rig.rotation.y = mRef.fromRotY + delta * e;
            } else {
                rig.rotation.y = mRef.toRotY;
            }

            if (p >= 1.0) {
                mRef.active = false;
                if (mRef.onComplete && !mRef.onCompleteCalled) {
                    mRef.onCompleteCalled = true;
                    mRef.onComplete();
                }
            }
        }
    }

    return { moveRef, moveTo, updateMovement };
}